import { render, staticRenderFns } from "./ramadanCategoryDetail.vue?vue&type=template&id=bb567e10&scoped=true"
import script from "./ramadanCategoryDetail.vue?vue&type=script&lang=js"
export * from "./ramadanCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ramadanCategoryDetail.vue?vue&type=style&index=0&id=bb567e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb567e10",
  null
  
)

export default component.exports